import localStorage from 'local-storage';

export const LocalStorageKeys = {
  FEATURE_TOGGLE_OVERRIDES: 'FEATURE_TOGGLE_OVERRIDES'
};

export const LocalStorageService = class {
  static set(key, value) {
    return localStorage.set(key, JSON.stringify(value));
  }

  static get(key) {
    return JSON.parse(localStorage.get(key));
  }

  static getJSON(key) {
    return JSON.parse(localStorage.get(key));
  }

  static remove(key) {
    return localStorage.remove(key);
  }
};
